import React, { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import { urlService } from '../../domain/services/urlService';
import { conf } from '../../domain/services/configService';
import { Modal } from '../responsive/organisms/Modal';
import { ExternalLinkDisclaimer } from './components/ExternalLinkDisclaimer';

const styles = {
  positioning: css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    width: 80%;
    max-width: 700px;
  `
};

// @todo - move this to Drupal config
const proxiedUrls = {
  es: [
    'www.ecotourchallenge.com',
    'www.palladiumhotelgroup.com',
    'es.visitwakayama.jp',
    'www.turismo.gal',
    'visitandorra.com',
    'andorraselected.com',
    'www.rolex.org',
    'news.nationalgeographic.org',
    'www.cell.com',
    'everest-pwa.nationalgeographic.org',
    'www.nationalgeographic.org',
    'nationalgeographic.org',
    'www.natgeodaytoursbytui.com'
  ],
  fr: [
    'www.rolex.org',
    'news.nationalgeographic.org',
    'www.cell.com',
    'everest-pwa.nationalgeographic.org',
    'www.nationalgeographic.org',
    'nationalgeographic.org'
  ],
  de: [
    'www.rolex.org',
    'news.nationalgeographic.org',
    'www.cell.com',
    'everest-pwa.nationalgeographic.org',
    'www.nationalgeographic.org',
    'nationalgeographic.org',
    'www.natgeodaytoursbytui.com'
  ]
};

const isProxiedUrl = url =>
  proxiedUrls[conf.siteCountryCode]
    ? proxiedUrls[conf.siteCountryCode].find(proxiedUrl => {
        const urlObject = new URL(`https://${proxiedUrl}`);
        // If url starts with "www", check that domain and its www-less version.
        if (urlObject.host.startsWith('www.')) {
          return (
            url.startsWith(proxiedUrl) ||
            url.startsWith(proxiedUrl.replace(/^www\./, ''))
          );
        }

        // Otherwise, use a regex to match any subdomain.
        const re = new RegExp(`^.*.?${proxiedUrl}`);
        return url.match(re);
      })
    : false;

export const LinkProxy = () => {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState();

  const close = () => {
    setOpen(false);
  };

  const cancelAndClose = () => {
    window.dataLayer.push({
      event: 'click_optout',
      action_button: 'Cancel',
      outclick: link
    });
    close();
  };

  const handleClick = e => {
    // Find its "a" parent, if any
    const a = e.target.closest('a');
    if (
      a &&
      a.href &&
      !a.getAttribute('data-no-external-disclaimer') &&
      urlService.isExternal(a.href) &&
      isProxiedUrl(a.href.replace(/https?:\/\//, ''))
    ) {
      e.preventDefault();
      setLink(a.href);
      setOpen(true);
    }
  };

  useEffect(() => {
    document.body.addEventListener('click', handleClick);
    return () => document.body.removeEventListener('click', handleClick);
  }, []);

  return (
    <Modal show={open} closeCb={cancelAndClose}>
      <div css={styles.positioning}>
        <ExternalLinkDisclaimer closeCb={close} link={link} />
      </div>
    </Modal>
  );
};
